export const CHANGE_ROOM_LINK_CLICKED = 'CHANGE_ROOM_LINK_CLICKED';
export const CHANGE_ROOM_LINK_CLICKED_VERSION = '1.0';

export type ChangeRoomLinkClickedPayload = {
  searchId: string;
  productDetailKey: string;
};

export type ChangeRoomLinkClickedParams = {
  searchId: string;
  productDetailKey: string;
};

export const createChangeRoomLinkClickedPayload = ({
  searchId,
  productDetailKey,
}: ChangeRoomLinkClickedParams): ChangeRoomLinkClickedPayload => ({
  searchId,
  productDetailKey,
});
